export default __webpack_public_path__ + "static/media/message.6c808b35.wav";